// extracted by mini-css-extract-plugin
module.exports = {"Evalanche__root":"K6gT","Evalanche__form":"VUpx"};